export default __webpack_public_path__ + "static/media/home-banner-small.88153a7f.jpg";